import { Button } from '@design-system';
import { FC } from 'react';

type Props = {
  label: string;
  onRemove: () => void;
};

export const FilterBadge: FC<Props> = ({ label, onRemove }) => (
  <Button
    icon="ic_close"
    label={label}
    onClick={onRemove}
    size="sm"
    type="button"
    variant="tertiary"
  />
);
